import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useDeUpdateSickLeaveMutation as useDeUpdateSickLeaveMutationType } from "@/modules/patients/detail/sick-leave-certificate/de/services/__generated__/useDeUpdateSickLeaveMutation.graphql"

const updateSickLeaveMutation = graphql`
  mutation useDeUpdateSickLeaveMutation($input: De_updateSickLeaveInput!) {
    de_updateSickLeave(input: $input) {
      de_SickLeave {
        id
        ...deSickLeaveFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useDeUpdateSickLeaveMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeUpdateSickLeaveMutationType>(
    updateSickLeaveMutation,
    params,
  )

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeUpdateSickLeaveMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeUpdateSickLeaveMutation }
